(function ($) {
  $(document).ready(function () {
	  if (typeof moment2 === "function") {
		  const moment = moment2;
		  window.moment = moment;
		  moment.locale('pl');
		  $(function () {
			  window.moment = moment;
			  moment.locale('pl');
		  });
	  }

    //search
    $(".icon-1-top-menu_search").on("click", function () {
      $(".search-block-wrap").toggleClass("active");
    });

    //left sidebar
    $(".menu-item-has-children>a").after(
      '<span class="arrow-in-down-wrap"><i class="arrow-in-down"></i></span>',
    );
    $(".menu-item-has-children li span").on("click", function (e) {
      $(this).parents(".menu-item-has-children").toggleClass("show");
      $(this).siblings(".dropdown-menu").toggleClass("show");
      e.preventDefault();
      e.stopPropagation();
    });

    //Google Website Translator
    $(".wpml-ls-sub-menu").append($(".gwt-wrap"));

    //stop and play animation for slider on main page
    /*    $(".wrap-pause-btn").on("click", function () {
      if ($(".pause-js").hasClass("active")) {
        $("#index-slider").carousel();
      } else {
        $("#index-slider").carousel("pause");
      }
      $(".pause-js").toggleClass("active");
    });*/

    // sidemenu
    let sidemenu = $(".orpeg-side-menu");
    sidemenu.find(".child_toggle").on("click", function (e) {
      $(this).parent().parent().toggleClass("open");
      $(this).parent().parent().find("> ul.children").slideToggle();
      $(this).toggleClass("isOpened");
    });

    $(document).on("click", ".inner_child", function (e) {
      $(this).parent().toggleClass("open");
      $(this).parent().find("> ul.children").slideToggle();
      $(this).toggleClass("isOpened");
    });

    // wrap element

    $(".inner_child").wrap("<div class='inner_child'></div>");
    $(document).find("div.inner_child img").removeClass("inner_child");
  });

  // custom dropdown
  var dropwdown_area = $(".main_filter");
  var cat_form = $("#cat_filter_form");
  dropwdown_area.find(".selected_value").on("click", function () {
    dropwdown_area.toggleClass("opened");
  });
  dropwdown_area.find("ul li").on("click", function () {
    let id = $(this).attr("data-id");
    $("#sort_filter_select").val(id);
    $(this).addClass("selected").siblings().removeClass("selected");
    let translatedTxt = $(this).attr("data-translated");
    dropwdown_area.find(".selected_value").val(translatedTxt);
    dropwdown_area.removeClass("opened");
    cat_form.submit();
  });

  // counter

  if ($(".counter_wrap").length > 0) {
    $(window).on("scroll", function () {
      let winH = $(window).height();
      let top = $(this).scrollTop();
      let data_viewd = $(".counter_wrap").attr("data-viewed");
      let couterOffset = $(".counter_wrap").offset().top;
      if ((top + (winH / 2) > couterOffset) && (data_viewd != 1)) {
        counter();
        return;
      }
    });
  }

  // ajax post load

  $(".cat__loadmore").on("click", function (e) {
    e.preventDefault();
    let __c = $(this);
    let ajaxURL = $(".ajaxURL").val();
    let currentPage = $(".currentPage").val();
    let maxPage = $(".maxPage").val();
    let cat_id = $(".cat_id").val();
    let posts_per_page = $(".posts_per_page").val();
    let order_by = $(".order_by").val();
    let order = $(".order").val();
    let tags = $(".tags").val();
    let date_query = $(".date_query").val();
    let meta_key = $(".meta_key").val();
    __c.addClass("loading");

    $.ajax({
      type: "post",
      url: ajaxURL,
      data: {
        action: "get_cat_products",
        currentPage,
        cat_id,
        posts_per_page,
        order_by,
        order,
        tags,
        date_query,
        meta_key,
      },
      success: function (rsp) {
        $(rsp).insertBefore(".loadmore-wraper");
        $(".currentPage").val(+$(".currentPage").val() + 1);
        if (maxPage == $(".currentPage").val()) {
          $(".cat__loadmore").fadeOut();
        } else {
          $(".cat__loadmore").fadeIn();
        }
        __c.removeClass("loading");
      },
    });
  });

  // Custom gallery
  let gallery = $(".single.single-post .gallery");
  gallery.find("a").on("click", function (e) {
    e.preventDefault();
    let src = $(this).attr("href");
    let caption = $(this).parent().parent().find("figcaption")
      ? $.trim($(this).parent().parent().find("figcaption").text())
      : undefined;
    $(".custom__gallery__popoup .img__container img").attr("src", src);
    if (caption != undefined) {
      $(".custom__gallery__popoup .img__meta  h4 ").text(caption);
    } else {
      $(".custom__gallery__popoup .img__meta  h4 ").text("");
    }

    $("body").addClass("custom__gallery_modal");
  });
  $(".custom__gallery__popoup__overlay").on("click", function () {
    $("body").removeClass("custom__gallery_modal");
  });

  let counter = () => {
    $(".counter_wrap").attr("data-viewed", 1);
    $(".counter_number").each(function () {
      var size = $(this).text().split(".")[1]
        ? $(this).text().split(".")[1].length
        : 0;
      $(this).prop("Counter", 0).animate({
        Counter: $(this).text(),
      }, {
        duration: 2000,
        step: function (func) {
          $(this).text(parseFloat(func).toFixed(size));
        },
      });
    });
  };

	/*lightbox.option({
		'resizeDuration': 200,
		'wrapAround': true
	})*/
	$(function () {
		$('[data-toggle="tooltip"]').tooltip()
	});

	// This example adds a marker to indicate the position of Bondi Beach in Sydney,
// Australia.

	let map_test = $('#map_test');
	console.log(map_test);

})(jQuery);
